<template>
  <div>
    <div
      v-if="event.scheduleProposedAt"
      data-test="scheduleProposedAt"
      class="mb-2"
    >
      {{
        $t(
          [
            "events:EventPage.Schedule.ProposedAt.text",
            "Schedule proposed: {\{ scheduleProposedAt }\}"
          ],
          {
            scheduleProposedAt: $dayjs.date(
              event.scheduleProposedAt,
              "fullTime"
            ),
            interpolation: { escapeValue: false }
          }
        )
      }}
    </div>
    <div
      v-if="event.registrationOpenAt || event.registrationOpenByBody"
      data-test="registrationOpenAt"
      class="mb-2"
    >
      {{
        $t(
          [
            "events:EventPage.Schedule.registrationOpenAt.text",
            "Schedule approved: {\{ registrationOpenAt }\} by {\{ registrationOpenByBody }\}"
          ],
          {
            registrationOpenAt: `${$dayjs.date(
              event.registrationOpenAt,
              "fullTime"
            )}`,
            registrationOpenByBody: event.registrationOpenByBody,
            interpolation: { escapeValue: false }
          }
        )
      }}
    </div>
  </div>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowEventApprovalLogs",
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  fragments: {
    eventApprovalLogs: gql`
      fragment _ on Event {
        scheduleProposedAt
        registrationOpenAt
        registrationOpenByBody
      }
    `
  }
};
</script>
